import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    question: '¿Cómo obtengo acceso?',
    answer: 'Descarga digital inmediata tras el pago.'
  }, {
    question: '¿Hay cargo mensual?',
    answer: 'NO. Pago único de $9.99.'
  }, {
    question: '¿Por qué el precio es tan bajo?',
    answer: 'Oferta de lanzamiento limitada.'
  }, {
    question: '¿Sirve para principiantes?',
    answer: 'Sí. Diseñado para todos los niveles.'
  }, {
    question: '¿Tengo acceso de por vida?',
    answer: 'Sí. Acceso permanente y actualizaciones gratuitas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-8 md:py-16 bg-parchment-100" data-id="element-98">
      <div className="max-w-3xl mx-auto px-4 sm:px-6" data-id="element-99">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-center text-navy-900 mb-6 md:mb-10" data-id="element-100">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-2.5 md:space-y-4" data-id="element-101">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-102">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-4 py-3 md:px-6 md:py-4 text-left flex justify-between items-center focus:outline-none hover:bg-gray-50 transition-colors" data-id="element-103">
                <span className="font-bold text-gray-800 text-base md:text-lg" data-id="element-104">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-gold-600" data-id="element-105" /> : <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-106" />}
              </button>

              <AnimatePresence data-id="element-107">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-108">
                    <div className="px-4 pb-3 md:px-6 md:pb-4 text-gray-600 border-t border-gray-100 pt-2 leading-relaxed" data-id="element-109">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}